import { Routes, Route } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useSignDocumentHandoff } from '../hooks';
import { EnvelopesListPage } from './EnvelopesListPage';
import { EnvelopeBuilderPage } from './EnvelopeBuilderPage';
import { EnvelopeReviewPage } from './EnvelopeReviewPage';
import { EnvelopeSentPage } from './EnvelopeSentPage';
import { EnvelopeDetailPage } from './EnvelopeDetailPage';

export function DocumentSignArchePage() {
  // Cross-arche intake lives at the arche ROOT because that is where a handoff
  // lands: `open_arche` navigates to `/a/<id>` with no sub-path, and the hook
  // then forwards to the builder for the envelope it created.
  const { isImporting } = useSignDocumentHandoff();

  return (
    <ArcheLayout>
      {isImporting ? (
        <div
          className="flex min-h-[40vh] flex-col items-center justify-center gap-3"
          role="status"
          aria-live="polite"
        >
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-hidden="true" />
          <p className="text-sm text-muted-foreground">Preparing your document for signature…</p>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<EnvelopesListPage />} />
          <Route path="/envelope/:envelopeId" element={<EnvelopeBuilderPage />} />
          <Route path="/envelope/:envelopeId/review" element={<EnvelopeReviewPage />} />
          <Route path="/envelope/:envelopeId/sent" element={<EnvelopeSentPage />} />
          <Route path="/envelope/:envelopeId/detail" element={<EnvelopeDetailPage />} />
        </Routes>
      )}
    </ArcheLayout>
  );
}
